import React from 'react';
import { StarIcons } from '../../../../../../../../icons/icons';
import { Question } from '../../../Interfaces';
interface IStarScore {
  breakdown: NonNullable<Question['starBreakdown']>;
}
export const StarScore = (props: IStarScore) => {
  const { breakdown } = props;

  const starData = [
    {
      key: 'situation',
      label: 'Situation',
      letter: 'S',
      color: 'purple',
      value: breakdown.situation,
    },
    {
      key: 'task',
      label: 'Task',
      letter: 'T',
      color: 'blue',
      value: breakdown.task,
    },
    {
      key: 'actions',
      label: 'Actions',
      letter: 'A',
      color: 'green',
      value: breakdown.actions,
    },
    {
      key: 'results',
      label: 'Results',
      letter: 'R',
      color: 'orange',
      value: breakdown.results,
    },
  ];

  const getColorClasses = (color: string) => {
    const colors: Record<string, { bg: string; text: string; badge: string }> =
      {
        purple: {
          bg: 'bg-purple-500',
          text: 'text-purple-600',
          badge: 'bg-purple-50 text-purple-700',
        },
        blue: {
          bg: 'bg-blue-500',
          text: 'text-blue-600',
          badge: 'bg-blue-50 text-blue-700',
        },
        green: {
          bg: 'bg-green-500',
          text: 'text-green-600',
          badge: 'bg-green-50 text-green-700',
        },
        orange: {
          bg: 'bg-orange-500',
          text: 'text-orange-600',
          badge: 'bg-orange-50 text-orange-700',
        },
      };
    return colors[color];
  };

  return (
    <div className='px-3 py-2'>
      <div className='flex items-center gap-1.5 mb-2'>
        <StarIcons className='w-3.5 h-3.5 text-yellow-500' />
        <span className='text-xs font-semibold text-gray-700'>
          STAR Analysis
        </span>
      </div>
      <div className='grid grid-cols-4 gap-2'>
        { starData.map((item) => {
          const percentage = Math.round(
            (item.value.score / item.value.total) * 100,
          );
          const colorClasses = getColorClasses(item.color);

          return (
            <div
                key={item.key}
                className='flex flex-col items-center gap-1 p-2 rounded-none bg-white border border-gray-100 hover:bg-gray-50 transition-colors shadow-sm'
            >
              <div
                  className={`w-7 h-7 rounded-none flex items-center justify-center text-white font-bold text-xs ${colorClasses.bg}`}
              >
                { item.letter }
              </div>
              <div className='text-center'>
                <div
                    className={`text-xs font-bold ${
                      percentage >= 70 ? 'text-gray-900' : 'text-gray-600'
                    }`}
                >
                  { percentage }%
                </div>
                <div className='text-[10px] text-gray-500 leading-tight'>
                  { item.value.score }/{ item.value.total }
                </div>
              </div>
            </div>
          );
        }) }
      </div>
    </div>
  );
};
